import api from '@mint-lib/api';

import { WithCurrenciesApiResponse } from '../../index.js';
import { MainCurrencyResponseType } from '../../types/types.js';
import { CURRENCY } from '../endpoints.js';
import { CurrencyCodeType } from '../getMainCurrencies/getMainCurrencies.types.js';

export const createMainCurrency = async (
  code: CurrencyCodeType,
): Promise<WithCurrenciesApiResponse<MainCurrencyResponseType>> => {
  return api.post(CURRENCY, { code }).then((data) => {
    return data as never as WithCurrenciesApiResponse<MainCurrencyResponseType>;
  });
};
